<script lang="ts" setup>
import type { Product } from '~/models';

import ProductList from './ProductList.vue';

const props = defineProps<{
  title: string;
  active: Product | null;
  products: Product[];
}>();

const emits = defineEmits<{
  (e: 'update:active', product: Product): void;
  (e: 'back'): void;
}>();

const onBack = (): void => {
  emits('back');
};

const onUpdateActive = (product: Product): void => {
  emits('update:active', product);
};
</script>

<template>
  <ProductList
    :active="props.active"
    :products="props.products"
    :is-mobile="true"
    class="product-list-mobile"
    @update:active="onUpdateActive"
  >
    <template #header>
      <div class="sticky top-0 z-10 shadow-lg w-full">
        <UContainer class="
          product-list-mobile__header
          py-2
          grid
          items-center
          bg-header
          uppercase
          font-roboto-bold
          leading-none
          text-center
        ">
          <UButton
            class="text-inherit hover:bg-header rounded-full"
            variant="ghost"
            data-test="back"
            aria-label="back"
            @click="onBack()"
          >
            <template #leading>
              <UIcon
                name="ic:round-chevron-left"
                class="text-2xl scale-150 text-inherit"
              />
            </template>
          </UButton>

          <span data-test="title">
            {{ props.title }}
          </span>
        </UContainer>

        <slot name="caption" />
      </div>
    </template>

    <slot />
  </ProductList>
</template>

<style lang="scss" scoped>
.product-list-mobile {
  &__header {
    grid-template-columns: 2.25rem 1fr 2.25rem;
  }
}
</style>
